<div
  *ngIf="(config.url && config.idsModule.pk && config.idsModule.sk && config.headersTable) else widgetError"
  class="w-100 h-100 d-flex flex-column justify-content-start align-items-center px-3 py-3 overflow-scroll"
>
<!--  <div>-->
<!--    <div-->
<!--      class="rounded-1 px-2 py-1 bg-primary-color d-flex justify-content-center align-items-center pointer"-->
<!--      (click)="openUploadModal()"-->
<!--    >-->
<!--      <span class="text-normal text-white d-none d-sm-inline"> Cargar archivos </span>-->

<!--    </div>-->
<!--  </div>-->
  <div class="w-100 h-100">
    <mng-list-objects-webcomponent
      [modeView]="modeView"
      [title]=""
      [config]="config"
      [language]="lang"
      [mode]="modeDam"
      [activeOpenModal]="activeOpenModal"
      (emiterActionUpload)="emiterActionUpload()"
      (emiterCloseModalUpload)="emiterCloseModalUpload()"
    >

    </mng-list-objects-webcomponent>
  </div>

</div>

<ng-template #widgetError>
  <div
    class="w-100 h-100 d-flex flex-column justify-content-start align-items-center px-2 py-3 overflow-scroll"
  >
    <div class="w-100 alert alert-danger d-flex align-items-center" role="alert">
      <span class="material-symbols-outlined text-title">error</span>
      <span class="text-normal ms-2 fw-bold">ERROR!!</span>
      <span class="text-normal ms-1">Widget is not properly configured</span>
    </div>
  </div>
</ng-template>
